export const RECEIVE_RESPONSE = "accessRequests/RECEIVE_RESPONSE";
export const API_ERROR = "accessRequests/API_ERROR";
export const RESET = "accessRequests/RESET";
export const PATCH_REQUEST = "accessRequests/PATCH_REQUEST";

export const STATUS_INITIAL = "accessRequests/STATUS_INITIAL";
export const STATUS_LOADING = "accessRequests/STATUS_LOADING";
export const STATUS_DONE = "accessRequests/STATUS_DONE";
export const STATUS_ERROR = "accessRequests/STATUS_ERROR";
